// src/content/auth-pages/register-hero.content.ts

export interface Benefit {
  title: string;
  desc: string;
}

export const invoiceRegisterHeroContent = {
  mainTitle: "Send payments across borders -",
  instantly: "instantly.",

  subtitle:
    "Instarails makes it easy for freelancers, contractors, and vendors working with US clients to send invoices and get paid fast.",

  benefits: [
    {
      title: "150+ Countries",
      desc: "Pay and get paid worldwide — no more waiting days for wire transfers.",
    },
    {
      title: "70+ Local Currencies",
      desc: "Send and receive in local currencies with best-in-class FX rates.",
    },
    {
      title: "Instant Transfers, Lower Fees",
      desc: "Save up to 80% compared to legacy payment networks.",
    },
    {
      title: "Enterprise-Grade Security",
      desc: "Bank-level encryption, security and real-time compliance.",
    },
  ] as Benefit[],

  // Optional extras you might want later
  logoAlt: "Instarails Logo",
  ctaText: "Create your account", // if you ever want to reuse in buttons
} as const;